import { render, staticRenderFns } from "./BulkEditTransactionModal.vue?vue&type=template&id=5a5a3641&"
import script from "./BulkEditTransactionModal.vue?vue&type=script&lang=ts&"
export * from "./BulkEditTransactionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports